// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"397":"c51e0157","416":"15695171","421":"bc86dec1","606":"af9e124c","745":"6483469e","831":"7b3528a4"}[chunkId] + ".css";
};